import { useEffect, useState } from 'react';

import {
  differenceFromNowInSeconds,
  formatRelativeTime,
  formatShortTimeAgo,
  formatTimeAgo,
} from '../utils/dateFormatter';

/** @typedef { import('models/user/_types').User } User */
/** @typedef { import('types/utilityTypes').Timestamp } Timestamp */

export interface TimeAgoProps {
  timestamp: string | number | Date;
  format?: 'long' | 'short' | 'relative';
}

export const TimeAgo: React.FC<TimeAgoProps> = ({
  timestamp,
  format = 'long',
}) => {
  const [formattedTimeAgo, setFormattedTimeAgo] = useState<string>('');

  const secondsAgo = differenceFromNowInSeconds(timestamp);

  // Triggers rerenders to update timestamp
  useEffect(() => {
    const updateTime = (time: string | number | Date) => {
      if (secondsAgo < 30) {
        setFormattedTimeAgo('now');
        return;
      }

      setFormattedTimeAgo(
        format === 'short'
          ? formatShortTimeAgo(time)
          : format === 'relative'
          ? formatRelativeTime(time)
          : formatTimeAgo(time)
      );
    };

    updateTime(timestamp);

    // If timestamp is more then 1 day old dont trigger rerenders
    if (secondsAgo > 60 * 60 * 24) {
      return;
    }

    const timer = setInterval(() => {
      updateTime(timestamp);
    }, 1000 * 20);

    return () => {
      clearInterval(timer);
    };
  }, [timestamp, format, secondsAgo]);

  return <>{formattedTimeAgo}</>;
};
